import { render, staticRenderFns } from "./IconLogo.vue?vue&type=template&id=dab48ec4&"
import script from "./IconLogo.vue?vue&type=script&lang=js&"
export * from "./IconLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports